import { Component, HostListener, OnInit, TemplateRef, ViewChild, inject, viewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { Location } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { AddAdminRemarkComponent } from 'src/app/AddThings/add-admin-remark/add-admin-remark.component';
import { AddCustomerComponent } from 'src/app/AddThings/add-customer/add-customer.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { INJECT_TYPE } from 'src/app/constants';
import { DialogItem } from 'src/app/dialog-item';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { AdminRemark } from 'src/model/customerAdminRemark';
import { Loan } from 'src/model/loan.model';
import { Status } from 'src/model/status.model';
import { CustomerService } from 'src/services/customer.service';
import { LoanService } from 'src/services/loan.service';
import { SpinnerService } from 'src/services/spinner.service';
import { CheckCustomerNecessaryFilesComponent } from '../check-customer-necessary-files/check-customer-necessary-files.component';
import { ViewCustomerRemarkComponent } from '../view-customer-remark/view-customer-remark.component';

@Component({
    selector: 'app-customer-list',
    templateUrl: './customer-list.component.html',
    styleUrls: ['./customer-list.component.scss'],
    standalone: false
})
export class CustomerListComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private location = inject(Location);
  private customerService = inject(CustomerService);
  private loanService = inject(LoanService);
  private spinnerService = inject(SpinnerService);

  customerList: Customer[] = [];

  displayedColumns: string[];
  dataSource = new MatTableDataSource;

  innerWidth: any;
  showRemark: string;

  selectedStatus: number;
  customerLoansList: Loan[] = [];

  isVerified: boolean;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  routeSubscription: any;
  selectedCompany: number;

  filteredValues = { filterStr: '', status: 0 };

  isLoanListReady = false;

  selectedCustomer: Customer;

  @ViewChild('popContent') loanListContent: TemplateRef<any>;
  customerDetailsTemplate = viewChild.required<TemplateRef<any>>('customerDetails');

  ngOnInit() {
    this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
      this.selectedCompany = (params.get('companyId') == undefined) ? undefined : +params.get('companyId');
      this.selectedStatus = (params.get('statusCode') == undefined) ? undefined : +params.get('statusCode');
      this.isVerified = (params.get('verified') == undefined) ? undefined : params.get('verified') == "true";
    });

    // get customer
    this.getAllCustomers();
    this.innerWidth = window.innerWidth;
    this.manageColumnsShown(this.innerWidth);
  }

  //detect screen size
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.innerWidth;
    this.manageColumnsShown(this.innerWidth);
  }

  manageColumnsShown(innerWidth: number) {
    //if inner width < small digital device, hide remark column
    if (innerWidth <= 450)
      this.displayedColumns = ['Name', 'ICNumber'];
    else {
      if (this.sharedService.isAdmin() || this.sharedService.isBossAccount() || this.sharedService.isFinance() || this.sharedService.isAuditor())
        this.displayedColumns = ['Name', 'ICNumber', 'Status', 'Remark', 'Action'];
      else
        this.displayedColumns = ['Name', 'ICNumber', 'Status'];
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();

    this.filteredValues['filterStr'] = filterValue;
    this.dataSource.filter = JSON.stringify(this.filteredValues);
  }

  filterByStatus() {
    this.filteredValues['status'] = this.selectedStatus;
    this.dataSource.filter = JSON.stringify(this.filteredValues);

    //construct activated route url -> append selectedStatusCode behind
    const urls = window.location.pathname.split("/");

    if (this.selectedStatus != null) {
      if (this.selectedCompany == undefined)
        this.location.replaceState(urls[1] + "/" + this.selectedStatus);
      else
        this.location.replaceState(urls[1] + "/" + urls[2] + "/" + this.selectedStatus);
    }
  }

  customFilterPredicate() {
    const myFilterPredicate = function (data: Customer, filter: string): boolean {
      const searchString = JSON.parse(filter);
      const searchFound = (data.Name.toString() + data.ICNumber.toString()).toLowerCase().trim().indexOf(searchString.filterStr.toLowerCase()) !== -1
      let statusFound;

      if (searchString.status != 0 && data.Status != undefined) {
        for (let i = 0; i < data.Status.length; i++) {

          statusFound = data.Status[i].StatusCode.toString().trim().indexOf(searchString.status) !== -1
          if (statusFound == true)
            break;
        }
      }
      else
        statusFound = true;

      return searchFound && statusFound
    }
    return myFilterPredicate;
  }

  goToCustomer(selectedID: number) {
    // console.log("selcted:" + selectedID);
    // this.router.navigateByUrl('/manageCustomer', { state: { id: selectedID } });
    this.router.navigate(['/manageCustomer', selectedID]);
  }

  convertStatusString(status: number) {
    if (status == this.enums.ACTIVE_CUST)
      return "ACTIVE";
    else if (status == this.enums.WARNING_CUST)
      return "WARNING";
    else if (status == this.enums.SETTLED_CUST)
      return "SETTLED";
    else if (status == this.enums.BAD_DEBT_CUST)
      return "BAD DEBT";
    else if (status == this.enums.LBD_CUST)
      return "LEGAL";
    else
      return "CP";

  }

  openAddCustomerDialog() {
    const modalRef = this.sharedService.openModal(AddCustomerComponent, "largeModal");

    //get company that was created
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const customer = entry;
      //append added customer to customer list
      this.customerList.push(customer);
      // console.log(JSON.stringify(this.customerList));
    });

    modalRef.result.then(() => {
      // console.log("added task")
      // this.cdr.detectChanges();
      this.refreshDataSource();
    })
  }

  getStatusColor(status: number) {
    let color: string;

    switch (status) {
      case this.enums.ACTIVE_CUST:
        color = "bg-primary";
        break;
      case this.enums.WARNING_CUST:
        color = "bg-warning";
        break;
      case this.enums.BAD_DEBT_CUST:
        color = "bg-dark";
        break;
      case this.enums.CP_CUST:
        color = "bg-info";
        break;
      case this.enums.LBD_CUST:
        color = "bg-secondary";
        break;
      default:
        color = "bg-success";
        break;
    }
    return color;
  }

  refreshDataSource() {
    this.dataSource.data = this.customerList;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSourceSort();
  }

  dataSourceSort() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'Status':
          // if status is empty
          if (item[property] == undefined)
            return ""
          //if contains status code
          else
            return item[property][0].StatusCode;

        case 'Action':
          //if sort by action column, sort VERIFIED
          return item["Verified"]
        default:
          return item[property];
      }
    };
  }

  checkNewCustomer(customer: Customer) {
    const dateCreated = new Date(customer.DateCreated);
    const today = new Date();
    if (dateCreated.getUTCMonth() == today.getUTCMonth() && dateCreated.getUTCFullYear() == today.getUTCFullYear())
      return true;
  }

  processCustomerStatus(statusJSON: any) {
    const statusList: Status[] = [];
    statusJSON.forEach(statusCode => {

      const index = statusList.findIndex(status => status.StatusCode === statusCode);
      if (index != -1)
        statusList[index].Occurrence = ++statusList[index].Occurrence;
      else {
        const status = new Status(statusCode, 1);
        statusList.push(status);
      }
    }
    );
    statusList.sort((a, b) => (a.StatusCode > b.StatusCode) ? 1 : -1);
    return statusList;
  }

  viewCustomerRemark(customerID: number, customerName: string) {
    const modalRef = this.sharedService.openModal(ViewCustomerRemarkComponent, "largeModal");
    modalRef.componentInstance.viewCustomerId = customerID;
    modalRef.componentInstance.viewCustomerName = customerName;

  }

  async showCustomerLoans(status: number, customerId: number) {
    this.spinnerService.show();
    this.selectedCustomer = this.customerList.find(c => c.ID == customerId);
    this.customerLoansList = await this.loanService.getCustomerLoans(customerId, { status: [status] });
    this.spinnerService.hide();
    this.sharedService.openModal(this.loanListContent, 'regularModal', { backdrop: true, keyboard: true, animation: false });
  }

  async getAllCustomers() {
    this.customerList = (this.selectedCompany == undefined)
      ? await this.customerService.getAllCustomers()
      : await this.customerService.getCompanyAllCustomers(this.selectedCompany, this.isVerified);

    this.dataSource = new MatTableDataSource<Customer>(this.customerList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = this.customFilterPredicate();
    this.dataSourceSort();

    if (this.selectedStatus != null)
      this.filterByStatus();
  }

  async viewCustomerImages(customer: Customer) {
    const files = await this.customerService.getCustomerAllFiles(customer.ID);
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr.set(files);
    i.injectContent = [new DialogItem(CheckCustomerNecessaryFilesComponent, { customerId: customer.ID })];
    i.imgViewerInjectContent = [new DialogItem(this.customerDetailsTemplate(), { name: customer.Name, ic: customer.ICNumberWithDash, dob: customer.DOB }, INJECT_TYPE.TEMPLATE)];
  }

  confirmBeforeVerifyCustomer(isVerify: boolean, customerID: number) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    const verifyMessage = (isVerify == true) ? "VERIFY" : "UNVERIFY";
    modalRef.componentInstance.message = "Confirm to " + verifyMessage + " this customer?";

    modalRef.result.then((confirm) => {
      if (confirm) {
        if (isVerify == true) {
          this.verifyCutsomer(customerID);
        } else {
          this.unverifyCutsomer(customerID);
        }
      }
    });
  }

  verifyCutsomer(customerID: number) {
    const xhr = this.restapi.postRequest(this.constructApi.getVerifyCustomer(customerID));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        // var json = JSON.parse(xhr.responseText);

        if (xhr.status == 200) {
          // window.location.reload();

          const index = this.customerList.findIndex(customer => Number(customer.ID) == Number(customerID));

          this.customerList[index].Verified = true;
          this.customerList[index].VerifiedBy = sessionStorage.getItem("username");
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  unverifyCutsomer(customerID: number) {
    const xhr = this.restapi.postRequest(this.constructApi.getUnverifyCustomer(customerID));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        // var json = JSON.parse(xhr.responseText);

        if (xhr.status == 200) {
          // window.location.reload();
          const index = this.customerList.findIndex(customer => Number(customer.ID) == Number(customerID));
          this.customerList[index].Verified = false;
          this.customerList[index].VerifiedBy = undefined;
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  addCustomerRemark(customerId: number, index: number) {
    const modalRef = this.sharedService.openModal(AddAdminRemarkComponent);
    modalRef.componentInstance.viewCustomerId = customerId;
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const remark: AdminRemark = entry;
      this.customerList[index].NeedAttention = remark.NeedAttention;
    });
  }
}
